module.exports = __webpack_public_path__ + "static/media/product-step-2.1dae347d.png";


//////////////////
// WEBPACK FOOTER
// ./src/sass/images/product-step-2.png
// module id = 229
// module chunks = 0